import { Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SORT_OPTIONS, DEFAULT_SORT_KEY } from '../hooks/useFCRecommendations';

/**
 * Dropdown selector for choosing table sort order
 * Reads available options from SORT_OPTIONS in useFCRecommendations
 * Supports grouped options for better organization
 */
export default function SortSelector({ value = DEFAULT_SORT_KEY, onChange }) {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e.target.value);
    }
  };

  // Group options by their group property
  const groupedOptions = {};
  Object.entries(SORT_OPTIONS).forEach(([key, option]) => {
    const group = option.group || 'Other';
    if (!groupedOptions[group]) {
      groupedOptions[group] = [];
    }
    groupedOptions[group].push({ key, ...option });
  });

  // Order groups for display (most useful first)
  const groupOrder = ['Recommended', 'Priority', 'Confidence', 'Delta', 'Financial', 'SKU', 'Other'];

  return (
    <InputGroup size="sm">
      <InputGroup.Text>
        <FontAwesomeIcon icon="sort-amount-down" />
      </InputGroup.Text>
      <Form.Select
        size="sm"
        value={value}
        onChange={handleChange}
        aria-label="Sort by"
      >
        {groupOrder.map(groupName => {
          const options = groupedOptions[groupName];
          if (!options || options.length === 0) return null;
          return (
            <optgroup key={groupName} label={`─ ${groupName} ─`}>
              {options.map(option => (
                <option key={option.key} value={option.key}>
                  {option.label}
                </option>
              ))}
            </optgroup>
          );
        })}
      </Form.Select>
    </InputGroup>
  );
}
